// import { Routes, Route } from "react-router-dom";
// import { ROUTES } from "./registry/routeRegistry";

// const CentralizedRoutes = () => (
//   <Routes>
//     {ROUTES.map(({ path, component: Component }) => (
//       <Route key={path} path={path} element={<Component />} />
//     ))}
//   </Routes>
// );

// export default CentralizedRoutes;

import { Routes, Route } from "react-router-dom";
// import { ROUTE_REGISTRY } from "./registry";
import { useSelector } from "react-redux";
// import ProtectedRoute from "./ProtectedRoute";

import { publicRoutes } from "./registry/public.routes";
import { taxesRoutes } from "./registry/taxes.routes";
import { nonTaxesRoutes } from "./registry/nonTaxes.routes";
import { misRoutes } from "./registry/miscellaneous.routes";

import { digitlizationRoutes } from "./registry/digitlization.routes";
import { expenditureRoutes } from "./registry/expenditure.routes";
import { grievanceRoutes } from "./registry/grievance.routes";
import { otherServicesRoutes } from "./registry/otherservices.routes";
import { svamitvaRoutes } from "./registry/svamitva.routes";
import SidebarV2 from "../SidebarV2";
import { meetingRoutes } from "./registry/meeting.routes";
import { reOrganizationRoutes } from "./registry/reorg.routes";
import { swmRoutes } from "./registry/swm.routes";

export default function CentralizedRoutes() {
  const isLoggedIn = useSelector(
    (state) => state.reducers?.loginreducer?.isLoggedIn,
  );

  // console.log('isLoggedIn',isLoggedIn)

  return (
    <Routes>
      {/* {ROUTE_REGISTRY.map(
        ({ path, component: Component, isProtected, roles }) => {
          // const element = isProtected ? (npm start
          //   // <ProtectedRoute roles={roles}>
          //     <Component />
          //   // </ProtectedRoute>
          // ) : (
          //   <Component />
          // );

          return <Route key={path} path={path} element={ <Component />} />;
        }
      )} */}

      {/* 1. Public Routes: Always rendered and available */}
      {publicRoutes.map(({ path, component: Component }) => (
        <Route key={path} path={path} element={<Component />} />
      ))}

      <Route element={<SidebarV2 />}>
        {/* 2. Protected Modules: ONLY injected into the DOM if logged in */}
        {/* {isLoggedIn && (
      <> */}
        {taxesRoutes.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        {nonTaxesRoutes.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        {misRoutes.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        {digitlizationRoutes.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        {expenditureRoutes.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        {grievanceRoutes.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        {otherServicesRoutes.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        {svamitvaRoutes.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        {swmRoutes.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        {meetingRoutes.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        {reOrganizationRoutes.map(({ path, component: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}

        {/* </>
      )} */}
      </Route>
    </Routes>
  );
}
